/**
 * FASE 21.2 — People Mutation Adapter
 */

import { updatePerson } from "../../api";
import { ALLOWED_PERSON_STATUS_FIELDS } from "../mutationSchemas";

/**
 * Update a person's spiritual or baptism status.
 * @param {Object} payload — validated
 * @param {Object} appScope
 */
export async function updatePersonStatusMutation(payload, appScope) {
  const now = Date.now();

  if (!ALLOWED_PERSON_STATUS_FIELDS.includes(payload.status_field)) {
    throw new Error(`status_field "${payload.status_field}" no está permitido`);
  }

  const updates = {
    [payload.status_field]: payload.new_value,
  };

  await updatePerson(
    payload.person_id,
    updates,
    payload.family_id ?? null,
  );

  return {
    ok:       true,
    entityId: payload.person_id,
    summary:  `Estado "${payload.status_field}" actualizado a "${payload.new_value}".`,
    meta:     { latency: Date.now() - now, auditType: "member_update" },
  };
}
